/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
// Create an observer to watch for the third-party review widget loading
// Function to clear the alt text
function clearReviewAltText() {
  const reviewImages = document.querySelectorAll('img[alt="user-image"]');
  if (reviewImages.length > 0) {
    reviewImages.forEach(function(img) {
      img.alt = ""; 
    });
  }
}

// 1. Run it immediately in case the widget is already loaded
clearReviewAltText();

// 2. Set up the observer in case the widget loads a few seconds later
const observer = new MutationObserver(clearReviewAltText);
observer.observe(document.body, { childList: true, subtree: true });

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
